<template>
    <div :class="{ 'dark text-white-dark': store.semidark }">
        <nav
            class="sidebar fixed min-h-screen h-full top-0 bottom-0 w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] z-50 transition-all duration-300">
            <div class="bg-white dark:bg-[#0e1726] h-full">
                <div class="flex justify-between items-center px-4 py-1.5">
                    <router-link to="/" class="main-logo flex items-center shrink-0">
                        <img class="flex-none h-12 lg:h-14 w-auto" src="/assets/images/gold/gold-logo.svg" alt="" />
                    </router-link>
                </div>
                <perfect-scrollbar
                    :options="{
                        swipeEasing: true,
                        wheelPropagation: false,
                    }"
                    class="h-[calc(100vh-100px)] relative">

                    <div class="flex">
                        <div class="w-full bg-gray-100  border-b border-gray-200">
                            <div class="pr-6 pt-6 pb-5 text-md">
                                <div class="flex items-center mb-4">
                                    <iconUserCircle class="font-bold text-blue-500 ml-2" />
                                    <RouterLink
                                        to="/users/user-account-settings"
                                        v-tooltip.top="'تعديل الملف الشخصي'"
                                    >
                                        <span class="font-bold text-blue-500"> {{ authStore.user?.name }}</span>
                                    </RouterLink>

                                </div>
                                <div class="flex items-center mb-2">
                                    <iconCal class="font-bold text-blue-500 ml-2" />
                                    <span class=" font-semibold text-gray-500">{{ now }}</span>
                                </div>
                                <div class="flex items-center mb-2">
                                    <IconChart class="font-bold text-blue-500 ml-2" />
                                    <span class="font-bold text-gray-500 pl-2 overflow-auto whitespace-nowrap">سعر الذهب:</span>
                                    <span class="text-red-500 font-bold">{{ goldPrice }}$</span>
                                    <Button
                                        variant="text"
                                        rounded
                                        @click="refreshGoldPrice"
                                        :disabled="goldPriceLoading"
                                        size="small"
                                        v-tooltip.top="'تحديث سعر الذهب'"
                                    >
                                        <span v-if="goldPriceLoading" class="pi pi-spin pi-sync"
                                              style="font-size: 0.8rem;"></span>
                                        <span v-else class="pi pi-history text-blue-500"
                                              style="font-size: 0.8rem;"></span>
                                    </Button>
                                </div>
                                <div class="flex items-center mb-2 pl-6">
                                    <icon-mapPin class="font-bold ml-2" />
                                    <Select :default-value="authStore.branch_id" size="small"
                                            :options="branchesStore.activeBranches()"
                                            option-label="name" option-value="id"
                                            class="block w-full px-2 border-none bg-transparent"
                                            @change="branchChanged" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="relative font-semibold space-y-0.5 p-4 py-0 mt-2">
                        <li class="nav-item">
                            <router-link to="/finance" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <icon-home class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('dashboard')
                                        }}</span>
                                </div>
                            </router-link>
                        </li>
                        <!--                        <li class="nav-item">-->
                        <!--                            <router-link to="/admin-conf/start-wizard" class="group" @click="toggleMobileMenu">-->
                        <!--                                <div class="flex items-center">-->
                        <!--                                    <icon-home class="group-hover:!text-primary shrink-0" />-->

                        <!--                                    <span-->
                        <!--                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">-->
                        <!--                                                الاعدادات الابتدائية-->
                        <!--                                            </span>-->
                        <!--                                </div>-->
                        <!--                            </router-link>-->
                        <!--                        </li>-->
                        <li class="menu nav-item"
                            v-if="authStore.canAny(['customer_orders', 'trader_orders', 'branch_transfers', 'other_orders_currency_exchange', 'other_orders_match_weights', 'other_orders_expenses', 'other_orders_set_cash_balance', 'other_orders_convert_gold_type'])">
                            <button
                                type="button"
                                class="nav-link group w-full"
                                :class="{ active: activeDropdown === 'transactions' && ['/customers', '/merchants', '/branches', '/other'].some(pf => route.path.startsWith(pf)) }"
                                @click="activeDropdown === 'transactions' ? (activeDropdown = null) : (activeDropdown = 'transactions')"
                            >
                                <div class="flex items-center">
                                    <IconTrans class="group-hover:!text-primary shrink-0" />
                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                                        {{ $t('transactions') }}
                                    </span>
                                </div>
                                <div :class="{ 'rtl:rotate-90 -rotate-90': activeDropdown !== 'transactions' }">
                                    <icon-caret-down />
                                </div>
                            </button>
                            <vue-collapsible :isOpen="activeDropdown === 'transactions'">
                                <ul class="sub-menu text-gray-500">
                                    <li v-if="authStore.can('customer_orders')">
                                        <router-link to="/customers/list" @click="toggleMobileMenu('transactions')">
                                            {{ $t('customers') }}
                                        </router-link>
                                    </li>
                                    <li v-if="authStore.can('trader_orders')">
                                        <router-link to="/merchants/list" @click="toggleMobileMenu('transactions')">
                                            {{ $t('merchants') }}
                                        </router-link>
                                    </li>
                                    <li v-if="authStore.can('branch_transfers')">
                                        <router-link to="/branches/list" @click="toggleMobileMenu('transactions')">
                                            {{ $t('branches') }}
                                        </router-link>
                                    </li>
                                    <li v-if="authStore.canAny(['other_orders_currency_exchange', 'other_orders_match_weights', 'other_orders_expenses', 'other_orders_set_cash_balance', 'other_orders_convert_gold_type'])">
                                        <router-link to="/other/list" @click="toggleMobileMenu('transactions')">
                                            {{ $t('other') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </vue-collapsible>
                        </li>
                        <!--                        <li class="nav-item">-->
                        <!--                            <router-link to="/currencies/list" class="group" @click="toggleMobileMenu">-->
                        <!--                                <div class="flex items-center">-->
                        <!--                                    <IconCurenceis class="group-hover:!text-primary shrink-0" />-->

                        <!--                                    <span-->
                        <!--                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{-->
                        <!--                                            $t('currencies')-->
                        <!--                                        }}</span>-->
                        <!--                                </div>-->
                        <!--                            </router-link>-->
                        <!--                        </li>-->
                        <li class="nav-item">
                            <router-link to="/products/list" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <IconProducts class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                                        {{ $t('products') }}
                                    </span>
                                </div>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/currencies/balances-list" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <iconBalance class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('balances')
                                        }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/currencies/prices" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <IconPriceList class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('price-list')
                                        }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li class="menu nav-item" v-if="authStore.canAny(['customer_orders', 'trader_orders'])">
                            <button
                                type="button"
                                class="nav-link group w-full"
                                :class="{ active: activeDropdown === 'reports' && ['/currencies/customer-debts', '/currencies/trader-debts', '/reports/tax-declaration'].includes(route.path) }"
                                @click="activeDropdown === 'reports' ? (activeDropdown = null) : (activeDropdown = 'reports')"
                            >
                                <div class="flex items-center">
                                    <IconTrans class="group-hover:!text-primary shrink-0" />
                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                                        {{ $t('reports') }}
                                    </span>
                                </div>
                                <div :class="{ 'rtl:rotate-90 -rotate-90': activeDropdown !== 'reports' }">
                                    <icon-caret-down />
                                </div>
                            </button>
                            <vue-collapsible :isOpen="activeDropdown === 'reports'">
                                <ul class="sub-menu text-gray-500">
                                    <li v-if="authStore.can('customer_orders')">
                                        <router-link to="/currencies/customer-debts"
                                                     @click="toggleMobileMenu('reports')">
                                            {{ $t('report_customer_debts') }}
                                        </router-link>
                                    </li>
                                    <li v-if="authStore.can('trader_orders')">
                                        <router-link to="/currencies/trader-debts" @click="toggleMobileMenu('reports')">
                                            {{ $t('report_trader_debts') }}
                                        </router-link>
                                    </li>
                                    <li v-if="authStore.canAny(['customer_orders', 'trader_orders'])">
                                        <router-link to="/reports/tax-declaration" @click="toggleMobileMenu('reports')">
                                            {{ $t('report_tax_declaration') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </vue-collapsible>
                        </li>
                        <li class="menu nav-item" v-if="authStore.isOwner()">
                            <button
                                type="button"
                                class="nav-link group w-full"
                                :class="{ active: activeDropdown === 'accounting' && ['/accounting/chart-of-accounts', '/currencies/trader-debts', '/reports/tax-declaration'].includes(route.path) }"
                                @click="activeDropdown === 'accounting' ? (activeDropdown = null) : (activeDropdown = 'accounting')"
                            >
                                <div class="flex items-center">
                                    <IconTrans class="group-hover:!text-primary shrink-0" />
                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                                        {{ $t('accounting') }}
                                    </span>
                                </div>
                                <div :class="{ 'rtl:rotate-90 -rotate-90': activeDropdown !== 'accounting' }">
                                    <icon-caret-down />
                                </div>
                            </button>
                            <vue-collapsible :isOpen="activeDropdown === 'accounting'">
                                <ul class="sub-menu text-gray-500">
                                    <li>
                                        <router-link to="/accounting/chart-of-accounts"
                                                     @click="toggleMobileMenu('accounting')">
                                            {{ $t('chart_of_accounts') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/accounting/journal-entries" @click="toggleMobileMenu('accounting')">
                                            {{ $t('journal_entries') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </vue-collapsible>
                        </li>
                        <li class="nav-item" v-if="authStore.isOwner()">
                            <router-link to="/admin-conf/branches-list" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <IconBranches class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('branches')
                                        }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="authStore.canAny(['customer_orders', 'trader_orders'])">
                            <router-link to="/admin-conf/customers-list" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <IconTrans class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('customers-merchants')
                                        }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="authStore.isOwner()">
                            <router-link to="/admin-conf/emp-list" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <IconEmployies class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('employees')
                                        }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="authStore.isOwner() || authStore.isBranchAdmin()">
                            <button
                                type="button"
                                class="nav-link group w-full"
                                :class="{ active: activeDropdown === 'settings' && ['/users/comp-account-settings'].includes(route.path) }"
                                @click="activeDropdown === 'settings' ? (activeDropdown = null) : (activeDropdown = 'settings')"
                            >
                                <div class="flex items-center">
                                    <IconSetting class="group-hover:!text-primary shrink-0" />
                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                                        {{ $t('settings') }}
                                    </span>
                                </div>
                                <div :class="{ 'rtl:rotate-90 -rotate-90': activeDropdown !== 'reports' }">
                                    <icon-caret-down />
                                </div>
                            </button>
                            <vue-collapsible :isOpen="activeDropdown === 'settings'">
                                <ul class="sub-menu text-gray-500">
                                    <li v-if="authStore.isOwner()">
                                        <router-link to="/settings/company" @click="toggleMobileMenu('settings')">
                                            {{ $t('settings_company') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/settings/branch" @click="toggleMobileMenu('settings')">
                                            {{ $t('settings_branch') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/settings/invoice-customer"
                                                     @click="toggleMobileMenu('settings')">
                                            {{ $t('settings_invoice') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/settings/taxes"
                                                     @click="toggleMobileMenu('settings')">
                                            {{ $t('settings_taxes') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/settings/payment-methods"
                                                     @click="toggleMobileMenu('settings')">
                                            {{ $t('settings_payment_methods') }}
                                        </router-link>
                                    </li>
                                    <li v-if="authStore.isOwner()">
                                        <router-link to="/settings/subscription"
                                                     @click="toggleMobileMenu('settings')">
                                            {{ $t('subscription') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </vue-collapsible>
                        </li>

                        <li class="nav-item">
                            <Divider></Divider>
                        </li>

                        <li class="nav-item">
                            <a href="#" class="group" @click="logout">
                                <div class="flex items-center">
                                    <IconLogout class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('sign-out')
                                        }}</span>
                                </div>
                            </a>
                        </li>

                        <li class="nav-item">
                            <router-link to="/services" class="group" @click="toggleMobileMenu">
                                <div class="flex items-center">
                                    <icon-globe class="group-hover:!text-primary shrink-0" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                                        {{ $t('services') }}
                                    </span>
                                </div>
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <a href="https://gold-alzaky.atlassian.net/servicedesk/customer/portals" class="group"
                               target="_blank">
                                <div class="flex items-center">
                                    <span class="pi pi-question-circle"></span>

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                            $t('support')
                                        }}</span>
                                </div>
                            </a>
                        </li>

                        <li class="nav-item hover:bg-yellow-50 hidden md:block">
                            <a href="#" class="group" @click="store.toggleGoldPricesBar">
                                <div class="flex items-center text-yellow-700">
                                    <span class="pi"
                                          :class="store.showGoldPricesBar ? 'pi-eye-slash' : 'pi-eye'" />

                                    <span
                                        class="ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark font-normal">
                                        {{ $t(store.showGoldPricesBar ? 'hide_gold_bar' : 'show_gold_bar') }}
                                    </span>
                                </div>
                            </a>
                        </li>
                    </ul>

                    <!--                    <div class="absolute sticky bottom-0 p-2 hover:bg-gray-200 w-full items-center bg-gray-200">-->
                    <!--                        <div class="pr-4">-->
                    <!--                            <a href="#" class="group" @click="store.toggleGoldPricesBar">-->
                    <!--                                <div class="flex items-center">-->
                    <!--                                    <span class="pi"-->
                    <!--                                          :class="store.showGoldPricesBar ? 'pi-eye-slash' : 'pi-eye'"></span>-->

                    <!--                                    <span-->
                    <!--                                        class="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{{-->
                    <!--                                            $t(store.showGoldPricesBar ? 'hide_gold_bar' : 'show_gold_bar')-->
                    <!--                                        }}</span>-->
                    <!--                                </div>-->
                    <!--                            </a>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </perfect-scrollbar>
            </div>
        </nav>
    </div>
</template>

<script lang="ts" setup>
    import { ref, onMounted, reactive } from 'vue';

    import { useAppStore } from '@/stores/index';
    import VueCollapsible from 'vue-height-collapsible/vue3';


    import IconMenuDashboard from '@/components/icon/menu/icon-menu-dashboard.vue';
    import IconCaretDown from '@/components/icon/icon-caret-down.vue';

    import IconGlobe from '@/components/icon/icon-globe.vue';
    import IconHome from '@/components/icon/gold-sidebar/icon-home.vue';
    import iconBalance from '../icon/gold-sidebar/icon-balance.vue';
    import IconBranches from '../icon/gold-sidebar/icon-branches.vue';
    import IconCurenceis from '../icon/gold-sidebar/icon-curenceis.vue';
    import IconEmployies from '../icon/gold-sidebar/icon-employies.vue';
    import IconPriceList from '../icon/gold-sidebar/icon-priceList.vue';
    import IconProducts from '../icon/gold-sidebar/icon-products.vue';
    import IconSetting from '../icon/gold-sidebar/icon-setting.vue';
    import IconTrans from '../icon/gold-sidebar/icon-trans.vue';
    import IconLogout from '../icon/gold-sidebar/icon-logout.vue';
    import IconMapPin from '../icon/gold-sidebar/icon-mapPin.vue';
    import IconChart from '../icon/gold-sidebar/icon-chart.vue';
    import iconUserCircle from '../icon/gold-sidebar/icon-user-circle.vue';
    import IconCal from '../icon/gold-sidebar/icon-cal.vue';
    import IconRefresh from '../icon/gold-sidebar/icon-refresh.vue';
    import { useAuthStore } from '@/stores/auth';
    import { format } from 'date-fns';
    import { ar } from 'date-fns/locale';
    import { useRoute, useRouter } from 'vue-router';
    import { useAssetsStore } from '@/stores/assets';
    import { useBranchesStore } from '@/stores/branches';

    const store = useAppStore();
    const authStore = useAuthStore();
    const activeDropdown: any = ref('');
    const subActive: any = ref('');
    const route = useRoute();

    onMounted(() => {
        const selector = document.querySelector('.sidebar ul a[href="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu')?.querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    });

    const toggleMobileMenu = (dropdown: string | null = null) => {
        activeDropdown.value = dropdown;

        if (window.innerWidth < 1024) {
            store.toggleSidebar();
        }
    };

    // Current Time
    const now = ref();
    const setNow = () => {
        // 2/12/2024 | 12:45 م
        now.value = format(new Date(), 'dd/MM/yyyy | hh:mm a', { locale: ar });
    };
    setNow();
    setInterval(setNow, 30000);

    // Gold Price
    const goldPrice = ref();
    const goldPriceLoading = ref(true);
    const getGoldPrice = () => {
        goldPriceLoading.value = true;

        authStore.request().get('/api/assets/xau-price').then(({ data }) => {
            goldPrice.value = data.xau_price;

            goldPriceLoading.value = false;
        });
    };
    const refreshGoldPrice = () => {
        goldPriceLoading.value = true;

        authStore.request().put('/api/assets/xau-price').then(({ data }) => {
            goldPrice.value = data.xau_price;

            goldPriceLoading.value = false;
        });
    };
    getGoldPrice();
    setInterval(getGoldPrice, 15 * 60 * 1000);

    const router = useRouter();

    // branches
    const branchesStore = useBranchesStore();
    const branchChanged = (branch) => {
        if (Number(branch.value) !== authStore.branch_id) {
            authStore.setBranchId(branch.value, false);

            router.go(0);
        }
    };

    // logout
    const logout = () => {
        authStore.logout();
    };
</script>
